/**
 * When app is locked (maintenance or server-down), render only MaintenanceScreen.
 * Blocks all routes including direct URL access. No Routes are rendered when locked.
 * On /login we never keep server-down lock so user can always reach the login form (e.g. after backend was restarted).
 */

import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { appLockStore } from '@/store/appLock.store'
import { MaintenanceScreen } from '@/pages/system/MaintenanceScreen'

export function AppLockGuard({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const [isLocked, setIsLocked] = useState(() => appLockStore.getState().isLocked)

  useEffect(() => {
    return appLockStore.subscribe(() => {
      setIsLocked(appLockStore.getState().isLocked)
    })
  }, [])

  // On login page with server-down lock: unlock so user sees the form (backend may be back; they'll get error on submit if not)
  useEffect(() => {
    if (typeof window !== 'undefined' && location.pathname.startsWith('/login')) {
      const state = appLockStore.getState()
      if (state.isLocked && state.reason === 'server-down') {
        appLockStore.unlockApp()
      }
    }
  }, [location.pathname])

  if (isLocked) {
    return <MaintenanceScreen />
  }

  return <>{children}</>
}
